export const SAFETY_CHECK_ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/heic'];
export const SAFETY_CHECK_MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export const SAFETY_CHECK_MAX_IMAGE_COUNT = 5;
